import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import JournalMiddleware from "../../../middleware/modules/accounting/journal";
import PrintJournal from "../../../components/utilities/print/default/journal";

const mapStateToProps = ({ auth, journal }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  dataPrint: journal.printJournal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => JournalMiddleware.getPrint(id),
    },
    dispatch
  );
};

class JournalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.id);
  }

  render() {
    const {
      isAuthenticated,
      isProcessing,
      isRegistered,
      isError,
      errorMessage,
    } = this.props;
    return <PrintJournal {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JournalContainer);
